import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMembershipsOverviewQuery = createQueryHook(
  MembershipsCreatorApiClient.getOverview,
  {
    queryKey: ['membershipsOverview'],
  },
)
